module.exports = __webpack_public_path__ + "static/media/ki.b5e25261.svg";